<div class="contact-section ptb-200">
    <section class="bg-image"  style="background-image: url('https://mdbcdn.b-cdn.net/img/Photos/new-templates/search-box/img4.webp');">
            <div class="mask d-flex align-items-center h-100 gradient-custom-3">
                <div class="container h-100">
                    <div class="row d-flex justify-content-center align-items-center h-100">
                        <div class="col-12 col-md-9 col-lg-7 col-xl-6">
                            <div class="card" style="border-radius: 15px;">
                                <div class="card-body p-5">
                                    <h2 class="text-uppercase text-center mb-5">Create an account</h2>
                                    <form #Group="ngForm" (ngSubmit)="Register(Group)">
                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="firstName">First Name</label>
                                            <input type="text" id="firstName" required [(ngModel)]="userData.firstName"  #firstName="ngModel" name="firstName"
                                                   class="form-control form-control-lg"/>
                                            <app-print-error-validation [control]="firstName"></app-print-error-validation>

                                        </div>
                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="lastName">Last Name</label>
                                            <input type="text" id="lastName" required [(ngModel)]="userData.lastName"  #lastName="ngModel" name="lastName"
                                                   class="form-control form-control-lg"/>
                                            <app-print-error-validation [control]="lastName"></app-print-error-validation>

                                        </div>
                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="userName">User Name</label>
                                            <input type="text" id="userName" required [(ngModel)]="userData.userName"  #userName="ngModel" name="userName"
                                                   class="form-control form-control-lg"/>
                                            <app-print-error-validation [control]="userName"></app-print-error-validation>

                                        </div>


                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="email">Your Email</label>
                                            <input type="email" id="email"  required [(ngModel)]="userData.email"  #email="ngModel" name="email"
                                                   class="form-control form-control-lg"/>
                                            <app-print-error-validation [control]="email"></app-print-error-validation>

                                        </div>
                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="phoneNumber">Phone Number</label>
                                            <input type="number"  pattern="^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$" id="phoneNumber" required [(ngModel)]="phoneNumber"  name="phoneNumber"
                                                   class="form-control form-control-lg"/>
\
                                        </div>

                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="password">Password</label>
                                            <input type="password" id="password" required [(ngModel)]="userData.password"  #password="ngModel" name="password"
                                                   class="form-control form-control-lg"/>
                                            <app-print-error-validation [control]="password"></app-print-error-validation>

                                        </div>

                                        <div class="form-outline mb-4">
                                            <label class="form-label" for="confirmPassword">Repeat your
                                                password</label>
                                            <input type="password" id="confirmPassword"  required [(ngModel)]="userData.confirmPassword"  #confirmPassword="ngModel" name="confirmPassword"
                                                   class="form-control form-control-lg"/>
                                            <app-print-error-validation [control]="confirmPassword"></app-print-error-validation>

                                        </div>

                                        <div class="d-flex justify-content-center">
                                            <button type="submit"   class="btn btn-success btn-block btn-lg gradient-custom-4 text-body">
                                                Register
                                            </button>
                                        </div>
                                        <p class="text-center text-muted mt-5 mb-0">Have already an account?
                                            <a   routerLink="/Account/login" class="fw-bold text-body"><u>Login here</u></a>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </section>
</div>
